import { render } from "./change-password2.vue?vue&type=template&id=13a4bc4e"
import script from "./change-password2.vue?vue&type=script&lang=js"
export * from "./change-password2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__